import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
// import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { IconButton } from 'src/components';
// import { DashboardStackParams } from 'src/navigations/AppNavigationProps';
import { pixelScaler } from 'src/themes/Metrics';
import { TripDetailModal } from '../../components/layout/TripDetailModal';

const ReturnSelectSeatView = React.lazy(() => import('./ReturnSelectSeatView'));

const ReturnSelectSeatScreen = () => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const { returnTripInfo, departureTripInfo } = useTripInfoState();
  const [isVisible, setVisible] = React.useState(false);
  // const { params } = useRoute<RouteProp<DashboardStackParams, 'SelectSeatScreen'>>();

  useLayoutEffect(() => {
    const selectSeatHeaderRight = () => (
      <IconButton
        icon={<Ionicons name="information-circle-outline" size={pixelScaler(24)} color="white" />}
        onPress={() => {
          setVisible(true);
        }}
      />
    );

    navigation.setOptions({
      headerRight: selectSeatHeaderRight,
      title: t('selectSeatOption', { title: t('returnTrip') }),
    });
  }, []);

  const handleClose = () => setVisible(false);

  return (
    <React.Suspense>
      <ReturnSelectSeatView />
      {isVisible && (
        <TripDetailModal
          isVisible={isVisible}
          onClose={handleClose}
          returnTripId={returnTripInfo?.tripId}
          departureTripId={departureTripInfo?.tripId}
        />
      )}
    </React.Suspense>
  );
};

export default ReturnSelectSeatScreen;
